<template>
  <validation-observer tag="div" ref="form">
    <validation-provider vid="trip_id" :name="lodash.upperFirst($t('receipt_orders.delivery_order'))" rules="required" v-slot="{ validated, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="lodash.upperFirst($t('receipt_orders.delivery_order')) + '*'"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <multiselect-ajax
            name="delivery_order_id"
            v-model.number="model.delivery_order_id"
            label="order_id"
            url="/delivery_orders">
        </multiselect-ajax>
      </b-form-group>
    </validation-provider>
    <validation-provider vid="customer_id" :name="lodash.upperFirst($t('receipt_orders.customer'))" rules="required" v-slot="{ validated, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="lodash.upperFirst($t('receipt_orders.customer')) + '*'"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <multiselect-ajax
            name="customer_id"
            v-model.number="model.customer_id"
            url="/customers?with=company"
            :custom-label="customerLabel"
        >
          <template v-slot:beforeList>
            <b-button variant="link" v-b-modal.customer-create-modal>+ {{ $t('Add new {something}',  { something: $t('receipt_orders.customer') }) }}</b-button>
            <customer-create-modal id="customer-create-modal"></customer-create-modal>
          </template>
        </multiselect-ajax>
      </b-form-group>
    </validation-provider>
    <validation-provider vid="ordered_at" :name="lodash.upperFirst($t('receipt_orders.ordered_at'))" rules="required" v-slot="{ validated, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="lodash.upperFirst($t('receipt_orders.ordered_at')) + '*'"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <date-picker
            name="ordered_at"
            format="DD MMMM YYYY"
            type="date"
            required
            :state="errors[0] ? false : (validated ? true : null)"
            :value="model.ordered_at"
            @input="model.ordered_at = $event && (`${$event} 00:00:00`)"
        >
        </date-picker>
      </b-form-group>
    </validation-provider>
<!--    <validation-provider vid="due_at" :name="lodash.upperFirst($t('receipt_orders.due_at'))" rules="" v-slot="{ validated, errors }">-->
<!--      <b-form-group-->
<!--          class="row mb-3"-->
<!--          label-cols-md="2"-->
<!--          :label="lodash.upperFirst($t('receipt_orders.due_at'))"-->
<!--          :state="errors[0] ? false : (validated ? true : null)"-->
<!--          :invalid-feedback="errors[0]"-->
<!--      >-->
<!--        <date-picker-->
<!--            name="due_at"-->
<!--            format="DD MMMM YYYY"-->
<!--            type="date"-->
<!--            :state="errors[0] ? false : (validated ? true : null)"-->
<!--            :value="model.due_at"-->
<!--            @input="model.due_at = $event && (`${$event} 00:00:00`)"-->
<!--        >-->
<!--        </date-picker>-->
<!--      </b-form-group>-->
<!--    </validation-provider>-->
    <hr>
    <b-form-group
        class="row mb-3"
        label-cols-md="2"
        :label="lodash.upperFirst($t('receipt_orders.receipt_items'))"
    >
      <template  v-for="(receipt_item, key) in model.receipt_items.filter((r) => r._action !== 'delete')">
        <div :key="`receipt_items.key.${key}`" class="row g-2">
          <div class="col-sm">
            <validation-provider :vid="`receipt_items.${key}.weight`" :name="lodash.upperFirst($t('receipt_items.weight'))" rules="required" v-slot="{ validated, errors }">
              <b-input-group :append="$t('units.kg')">
                <numeral-input
                    :name="`receipt_items[${key}][weight]`"
                    required
                    style="text-align: right"
                    :placeholder="lodash.upperFirst($t('receipt_items.weight'))"
                    :state="errors[0] ? false : (validated ? true : null)"
                    v-model="receipt_item['weight']"
                />
              </b-input-group>
            </validation-provider>
          </div>
          <div class="col-sm">
            <validation-provider :vid="`receipt_items.${key}.size`" :name="lodash.upperFirst($t('receipt_items.size'))" rules="required" v-slot="{ validated, errors }">
              <b-input-group :append="$t('units.tail_per_kg')">
                <numeral-input
                    :name="`receipt_items[${key}][size]`"
                    required
                    style="text-align: right"
                    :placeholder="lodash.upperFirst($t('receipt_items.size'))"
                    :state="errors[0] ? false : (validated ? true : null)"
                    v-model="receipt_item['size']"
                />
              </b-input-group>
            </validation-provider>
          </div>
<!--          <div class="col-sm">-->
<!--            <numeral-input-->
<!--                :name="`receipt_items[${key}][total]`"-->
<!--                readonly-->
<!--                style="text-align: right"-->
<!--                :placeholder="lodash.upperFirst($t('receipt_items.total'))"-->
<!--                :value="receipt_item['total']"-->
<!--            />-->
<!--          </div>-->
        </div>
        <div :key="`receipt_items.key.${key}.delete`" class="row">
          <div class="col">
            <div class="float-end">
              <b-button size="sm" tag="span" variant="link" class="text-danger" @click="removeItem(key)">{{ $t('Delete') }}</b-button>
            </div>
          </div>
        </div>
      </template>
      <div class="clearfix">
        <div class="float-end">
          <b-button size="sm" tag="span" variant="link" @click="addItem">{{ $t('Add new {something}', { something: '' }) }}</b-button>
        </div>
      </div>
    </b-form-group>
    <hr>
<!--    <b-form-group-->
<!--        class="row mb-3"-->
<!--        label-cols-md="2"-->
<!--        :label="lodash.upperFirst($t('receipt_orders.total'))"-->
<!--    >-->
<!--      <numeral-input-->
<!--        name="total"-->
<!--        readonly-->
<!--        :value="model.total"-->
<!--      />-->
<!--    </b-form-group>-->
    <validation-provider vid="description" :name="lodash.upperFirst($t('models.description'))" rules="" v-slot="{ validated, errors }">
      <b-form-group
        class="row mb-3"
        :label="lodash.upperFirst($t('models.description'))"
        :state="errors[0] ? false : (validated ? true : null)"
        :invalid-feedback="errors[0]"
      >
        <editor
          ref="editor"
          v-if="$parent.$parent.$options.name !== 'BModal'"
          class="form-control"
          :init="editorInit"
          inline
          plugins="lists link image paste help wordcount"
          toolbar="undo redo | styleselect | fontselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent"
          v-model="model.description"
        />
        <b-form-textarea v-else v-model="model.description" />
      </b-form-group>
    </validation-provider>
  </validation-observer>
</template>

<script>
  import FormModel from './model';
  import CustomerCreateModal from '../modals/customer-create';

  export default {
    extends: FormModel,
    components: {
      CustomerCreateModal,
    },
    data() {
      return {
        model: {
          ...this.value,
          receipt_items: [
              ...((this.value.receipt_items || []).length ? this.value.receipt_items : [{}])
          ]
        }
      }
    },
    mounted() {
      //
    },
    methods: {
      addItem() {
        this.model.receipt_items.push({})
      },
      removeItem(index) {
        const deliveryItem = this.model.receipt_items[index]
        if ((deliveryItem || {}).id) {
          this.$set(this.model.receipt_items[index], '_action', 'delete')
        } else {
          this.model.receipt_items.splice(index, 1)
        }
      },
      customerLabel(customer) {
        let label = customer.name;

        if (customer.company !== null) {
          label += ` (${customer.company.name})`;
        }

        return label;
      },
    }
  }
</script>
